// @react/hooks/useTaskView.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskViewStore } from '@core/stores';

/**
 * React hook for TaskView operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskView } from '@react/hooks';
 *
 * const TaskViewList = observer(() => {
 *   const store = useTaskView();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskView() {
  return taskViewStore;
}
